import { T_TERMS_AND_CONDITIONS_PAGE_CONSTANTS } from './TYPES'

const FR_TERMS_AND_CONDITIONS_PAGE_CONSTANTS: T_TERMS_AND_CONDITIONS_PAGE_CONSTANTS =
  {
    PAGE_KICKER: 'GRIFFYREADS',
    PAGE_TITLE: 'Termes et conditions',
    PAGE_CONTENT: [
      {
        TITLE: 'Introduction',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              "Bienvenue chez GriffyReads. Les présentes Conditions générales (« Conditions ») régissent votre utilisation de notre application basée sur des quiz conçue pour les enfants et les adultes (« l'Application »). En accédant à l'Application ou en l'utilisant, les utilisateurs adultes acceptent les Conditions.",
              "L'objectif de l'Application est de promouvoir la lecture hors ligne chez les enfants. À cette fin, l'Application propose une base de données de quiz à choix multiples visant à tester la compréhension de lecture. Elle fonctionne également comme une plateforme communautaire, où tout utilisateur adulte (parents, enseignants, etc.) peut uploader des quiz.",
              "Les enfants — appelés « aventuriers » — utilisent la plateforme en sélectionnant un livre spécifique, en le lisant hors ligne, puis en complétant un quiz composé de cinq questions à choix multiples conçues pour tester leur compréhension du texte. Ils gagnent des points pour chaque bonne réponse, ce qui contribue au développement de leur mascotte, un jeune griffon nommé Griffy. Les aventuriers peuvent jouer individuellement ou participer à des événements et compétitions organisés par des utilisateurs adultes, aux côtés d'autres aventuriers. La plateforme ne contient que certaines informations d'identification spécifiques à chaque livre (par exemple : auteur, éditeur, image de couverture), mais pas le livre lui-même."
            ]
          }
        ]
      },
      {
        TITLE: 'Utilisateurs et inscription',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              "L'Application est destinée à être utilisée par des adultes et des enfants. Le terme « adulte » désigne une personne ayant atteint l'âge de la majorité, soit 18 ans. Les enfants de moins de 13 ans ne peuvent utiliser l'Application que sous la supervision d'un adulte.",
              'Les utilisateurs adultes peuvent créer des compétitions pour les enfants et sont encouragés à uploader de nouveaux quiz.',
              "Pour utiliser l'Application, les utilisateurs adultes doivent s'enregistrer en fournissant des données spécifiques. Pour se connecter, ils utilisent une adresse e-mail et un mot de passe. Seuls les adultes sont autorisés à créer un compte. Une fois inscrits, ils peuvent créer un compte enfant (aventurier). Ensuite, les aventuriers peuvent se connecter eux-mêmes à leur compte.",
              "Après l'inscription, une période d'essai de 14 jours est proposée. Les utilisateurs adultes doivent choisir un plan d'abonnement pour avoir un accès complet à l'application au-delà de cette période d'essai.",
              "Les utilisateurs adultes sont responsables de l'exactitude des informations fournies lors de l'inscription."
            ]
          }
        ]
      },
      {
        TITLE: "Utilisation de l'application",
        CONTENT: [
          {
            TYPE: 'LIST',
            CONTENT: [
              "Participation au quiz: Les enfants (aventuriers) lisent le livre sélectionné (ou, pour les plus jeunes, celui-ci leur est lu à voix haute), puis ils complètent des quiz dans l'Application pour tester leur compréhension du texte. Chaque bonne réponse leur fait gagner des points, ce qui permet à leur Griffy de devenir plus fort et plus grand. L'accumulation de points permet également de monter de niveau et de faire évoluer leur personnage. ",
              "ions et événements: Les utilisateurs adultes peuvent créer des compétitions auxquelles les aventuriers peuvent participer (ces compétitions sont généralement organisées par des enseignants pour leurs élèves). Les administrateurs de l'Application peuvent créer ce que l'on appelle des événements, qui sont des compétitions publiques généralement ouvertes à des groupes plus larges (par exemple : des tranches d'âge).",
              " participants peuvent consulter leur classement dans le tableau des scores (l'organisateur de la compétition ou de l'événement a la possibilité d'anonymiser ce tableau), et des badges sont attribués aux meilleurs classés.",
              "èque virtuelle et échange de livres : Les enfants peuvent créer une « bibliothèque virtuelle » dans l'Application à partir des livres qu'ils possèdent déjà et indiquer leur intention de partager ces livres avec leurs amis au sein de l'Application.",
              "amis : Les enfants peuvent ajouter d'autres enfants à leur liste d'amis, ce qui leur permet de consulter les livres des uns et des autres, facilitant ainsi l'échange de livres et le maintien du contact."
            ]
          }
        ]
      },
      {
        TITLE: 'Contenu et conduite',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              "Les utilisateurs adultes sont responsables du contenu qu'ils fournissent et de leur conduite lors de l'utilisation de l'application. Tout contenu ou comportement inapproprié, offensant ou préjudiciable peut entraîner la suspension ou la résiliation du compte. ",
              "En uploadant, soumettant ou mettant de toute autre manière à disposition des quiz ou du contenu connexe («Contenu de l'utilisateur») par l'intermédiaire de l'application, les utilisateurs adultes conviennent que ce contenu devient la propriété intellectuelle exclusive d'Adonis Consultancy. Les utilisateurs adultes cèdent, transfèrent et transmettent irrévocablement à Adonis Consultancy tous les droits, titres et intérêts sur le contenu de l'utilisateur, y compris, mais sans s'y limiter, tous les droits d'auteur et tous les autres droits de propriété intellectuelle qui s'y trouvent. ",
              "Les utilisateurs adultes reconnaissent et acceptent en outre qu'Adonis Consultancy a le droit illimité d'utiliser, de reproduire, de modifier, de distribuer, d'afficher, d'exécuter et d'exploiter le contenu de l'utilisateur à toute fin, commerciale ou autre, sans compensation, attribution ou autre préavis. ",
              "En soumettant du contenu, les utilisateurs adultes déclarent et garantissent qu'ils disposent de tous les droits et autorisations nécessaires pour accorder cette cession, et que le contenu n'enfreint aucun droit de tiers."
            ]
          }
        ]
      },
      {
        TITLE: 'Confidentialité',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              "Votre utilisation de l'application est également régie par notre politique de confidentialité, qui détaille la façon dont le Contrôleur recueille, utilise et protège vos informations personnelles."
            ]
          }
        ]
      },
      {
        TITLE: 'Abonnement et paiement',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              "L'Application fonctionne selon un modèle d'abonnement, dans lequel les utilisateurs adultes paient un montant spécifique correspondant à un plan d'abonnement afin de donner à leurs enfants accès à la plateforme une fois la période d'essai de 14 jours expirée. En souscrivant à un abonnement spécifique, les utilisateurs adultes acceptent de payer les frais d'abonnement correspondants et les taxes applicables."
            ]
          }
        ]
      },
      {
        TITLE: "Modifications de l'Application",
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              "Nous nous réservons le droit de modifier ou d'interrompre l'Application, de manière temporaire ou permanente, avec ou sans préavis. Nous ne saurions être tenus responsables de toute modification, suspension ou interruption de l'Application."
            ]
          }
        ]
      },
      {
        TITLE: 'Résiliation',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              "Nous nous réservons le droit de résilier ou de suspendre votre accès à l'Application, à notre seule discrétion et sans préavis, en cas de comportement que nous estimons contraire aux présentes Conditions ou préjudiciable aux autres utilisateurs ou à l'Application."
            ]
          }
        ]
      },
      {
        TITLE: 'Limitation de responsabilité',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              "Dans toute la mesure permise par la loi, GriffyReads ne pourra être tenue responsable des dommages indirects, accessoires, spéciaux, consécutifs ou punitifs résultant de ou liés à votre utilisation de l'Application."
            ]
          }
        ]
      },
      {
        TITLE: 'Droit applicable',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              "Les présentes Conditions sont régies et interprétées conformément au droit belge, indépendamment du fait que ses règles de conflit de lois prescrivent l'application d'un autre droit."
            ]
          }
        ]
      },
      {
        TITLE: 'Contactez-nous',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              'Si vous avez des questions ou des préoccupations concernant ces Conditions, veuillez nous contacter à contact@griffyreads.com.'
            ]
          }
        ]
      }
    ]
  }

export default FR_TERMS_AND_CONDITIONS_PAGE_CONSTANTS
